import DatePicker from './picker/date-picker';

export default DatePicker;


// WEBPACK FOOTER //
// ./src/components/common/datePicker/index.js